module.exports = __webpack_public_path__ + "static/media/logout.649464a2.svg";